'use client';

import type { ProfileModuleDto } from '@up2stay/up2promo-api-client';

import { cn } from '../../utils/cn';
import { useProfileLayout } from '../layouts/profile-layout-context';

interface BiographyModuleDisplayProps {
  module: ProfileModuleDto;
}

type BiographyModuleConfig = {
  type: 'biography';
  content: string;
};

function getBiographyConfig(
  rawConfig: Record<string, unknown>,
): BiographyModuleConfig {
  return {
    type: 'biography',
    content: (rawConfig.content as string) || '',
  };
}

/**
 * Displays a biography module as plain text.
 */
export function BiographyModuleDisplay({
  module,
}: BiographyModuleDisplayProps) {
  const layout = useProfileLayout();
  const config = getBiographyConfig(module.config || {});

  if (!config.content) {
    return null;
  }

  return (
    <p
      className={cn(
        'whitespace-pre-wrap break-words leading-relaxed [overflow-wrap:anywhere]',
        layout === 'centered' &&
          'px-1.5 text-center text-[13.5px] leading-[1.6] text-[var(--muted)] @min-[880px]/profile:px-5 @min-[880px]/profile:text-[14px]',
        layout === 'classic' &&
          'pt-2 text-[14.5px] leading-[1.65] text-[var(--text)] @min-[880px]/profile:pt-0 @min-[880px]/profile:text-[15px] @min-[880px]/profile:leading-[1.7]',
        layout === 'cards' && 'text-[14px] leading-[1.6] text-[var(--text)]',
      )}
    >
      {config.content}
    </p>
  );
}
